
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { ArrowRight, Clock, Users, Shield, Sparkles, Gift } from "lucide-react";
import WaitlistIncentiveWidget from "../WaitlistIncentiveWidget";

const EarlyAccessSection = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Accès Anticipé",
      subtitle: "Rejoignez la liste d'attente",
      description: "Soyez parmi les premiers à découvrir notre plateforme révolutionnaire pour créer des moments inoubliables.",
      cta: "Rejoindre la liste d'attente",
      features: ["Accès prioritaire à la plateforme", "Notifications exclusives sur le lancement", "Support client dédié", "Fonctionnalités beta en avant-première"]
    },
    en: {
      title: "Early Access",
      subtitle: "Join the waitlist",
      description: "Be among the first to discover our revolutionary platform for creating unforgettable moments.",
      cta: "Join the waitlist",
      features: ["Priority access to the platform", "Exclusive launch notifications", "Dedicated customer support", "Beta features preview"]
    },
    de: {
      title: "Früher Zugang",
      subtitle: "Zur Warteliste",
      description: "Seien Sie unter den Ersten, die unsere revolutionäre Plattform für unvergessliche Momente entdecken.",
      cta: "Warteliste beitreten",
      features: ["Prioritärer Zugang zur Plattform", "Exklusive Launch-Benachrichtigungen", "Dedizierter Kundensupport", "Beta-Features Vorschau"]
    }
  };

  return (
    <section className="relative py-20 md:py-32 bg-gradient-to-br from-gray-50 via-white to-legatia-light/30 overflow-hidden">
      {/* Enhanced background decorations */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-[15%] w-72 h-72 bg-gradient-to-r from-legatia-orange/10 to-legatia-yellow/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-[10%] w-80 h-80 bg-gradient-to-r from-legatia-yellow/8 to-legatia-green/8 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: "2s"
        }}></div>
        <div className="absolute top-1/3 right-1/4 w-6 h-6 bg-legatia-orange/20 rounded-full animate-bounce"></div>
        <div className="absolute bottom-1/3 left-1/3 w-4 h-4 bg-legatia-yellow/30 rounded-full animate-bounce" style={{
          animationDelay: "1s"
        }}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Centered form */}
        <div className="flex justify-center items-center max-w-7xl mx-auto">
          <div className="animate-fade-in" style={{
            animationDelay: "0.8s"
          }}>
            <div className="relative">
              {/* Enhanced widget container */}
              <div className="absolute inset-0 bg-gradient-to-br from-legatia-orange/20 to-legatia-yellow/20 rounded-3xl transform translate-x-2 translate-y-2"></div>
              <div className="relative z-10 transform hover:scale-[1.02] transition-transform">
                <WaitlistIncentiveWidget />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EarlyAccessSection;
